export enum PERMISSION {
	hasDisplay,
	hasPreroll,
	hasSem,
	hasGeoFence,
	hasGeoVideo,
	hasCtv,
	hasSocial,
	hasTelevision,
	hasDOOH,
	hasRenewalStrategy,
	hasRadio,
	hasGAM,
	hasStandaloneGAM,
	hasGamMapAccess,
	hasNoGamMapAccess,
	showPlacements,
	hasSEMPrintableAccess,
	hasTelevisionPrintableAccess,
	hasDisplayPrintableAccess,
	hasPrerollPrintableAccess,
	hasCtvPrintableAccess,
	hasPrerollCompletionAccess,
	hasSocialPrintableAccess,
	hasGeofencePrintableAccess,
	hasGeovideoPrintableAccess,
	hasStreaminAudioPrintableAccess,
	hasOfflineVisits,
	hasProgrammaticsProductsOfflineVisits,
	hasKeywordsTargeting,
	hasHotjarAccess,
	hasSimplifiCTV,
	hasSimplifiCTVPrintableAccess,
	hasYoutubeViews,
	hasSEMConversionsAccess,
	hasYoutubeCostAccess,
	hasSocialMediaCostAccess,
	hasEmail,
	hasEmailPrintableAccess,
	hasDisplayLineItemsAccess,
	hasPrerollLineItemsAccess,
	customizeAdvertiserLimit,
	resourceLibrary,
	hasRadioTriton,
	hasTritonPrintableAccess,
	customizeCampaignLimit,
	hasResponsiveDisplay,
	hasResponsiveDisplayPrintableAccess,
	hasGAMPrintableAccess,
	hasOverviewPrintableAccess,
	hasOverviewCSVAccess,
	hasGamLineitemAccess,
	hasGamScreenshotAccess,
	hasLookerPOC,
	hideItem,
	hasDOOHPrintableAccess,
	hasDOOHVideo,
	toRemoveProductInNavigation // Permission to remove the widget from configuration
}

export interface PermissionsObj {
	isGeneric: boolean;
	flags: PERMISSION[];
}

export interface PermissionsWithBooleanCheckObj {
	flags: any[];
	flagCheck: boolean;
}
